// Assets
require.context('../media/', true, /^\.\/.*\.*/);
require.context('../fonts/', true, /^\.\/.*\.*/);

import '../styles/styles.scss';

import $ from 'jquery';
import barba from '@barba/core';
import Lenis from 'lenis';

import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);

import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard, Autoplay, EffectFade, Controller } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

let Site;

(function ($) {
	'use strict';

	Site = {
		init: function () {
			var self = this;

			// The persistent navigation is bound only once.
			self.nav();
			self.initResizeRefresh();

			if (document.querySelector('[data-barba="wrapper"]') && !document.body.classList.contains('wp-admin')) {
				self.initBarba();
			}
			else {
				self.initPageScripts();
			}

		},
		/** Refresh Lenis and ScrollTrigger after live browser resizing settles. */
		initResizeRefresh: function() {
			var self = this;
			var resizeTimer;

			window.addEventListener('resize', function() {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function() {
					if (self.lenis) self.lenis.resize();
					ScrollTrigger.refresh(true);
				}, 150);
			}, { passive: true });
		},
		/** Recreate Lenis after each Barba swap so page measurements stay current. */
		initLenis: function() {
			var self = this;

			if (self.lenis) {
				gsap.ticker.remove(self.lenisTick);
				self.lenis.destroy();
				self.lenis = null;
				self.lenisTick = null;
			}

			if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

			self.lenis = new Lenis({
				autoRaf: false
			});

			self.lenis.on('scroll', ScrollTrigger.update);

			self.lenisTick = function(time) {
				self.lenis.raf(time * 1000);
			};
			gsap.ticker.add(self.lenisTick);

			gsap.ticker.lagSmoothing(0);
		},
		/** Initialize scripts against the current page DOM. */
		initPageScripts: function() {
			var self = this;
			self.initLenis();
			self.projectList('.project-list');
			self.initTextSliders();
			self.initLatestProject();

			document.querySelectorAll('.js-stacking-steps').forEach((section) => {
				self.stackingSteps(section);
			});

			document.querySelectorAll('.js-awards').forEach(function(elt) {
				self.awards(elt);
			});

			document.querySelectorAll('.js-page-hero-about').forEach(function(elt) {
				self.pageHeroAbout(elt);
			});

			document.querySelectorAll('.js-page-hero-homepage').forEach(function(elt) {
				self.pageHeroHomepage(elt);
			});

			document.querySelectorAll('.js-showreel').forEach(function(elt) {
				self.showreel(elt);
			});

			self.partnersMarquee();

			self.textReveal();
			self.titleReveal();
			self.copyReveal();
			self.endPageAboutParallax();

			self.scrolltriggerAnimations();
		},
		/** Reset persistent CSS animations before observing the next page. */
		resetInviewAnimations: function() {
			const animatedElements = document.querySelectorAll('[class*="ivanim-"]');

			animatedElements.forEach(function(element) {
				element.classList.remove('is-inview');
			});

			// Commit the reset before an immediately-visible element can re-enter.
			if (animatedElements.length) {
				void animatedElements[0].offsetWidth;
			}
		},
		/** Refresh scroll measurements after Barba has laid out the new page. */
		refreshPageLayout: function() {
			var self = this;

			window.requestAnimationFrame(function() {
				window.requestAnimationFrame(function() {
					if (self.lenis) self.lenis.resize();
					ScrollTrigger.refresh();
				});
			});
		},
		/** Track virtual page loads after Barba replaces the page container. */
		trackAnalyticsPageView: function(data) {
			if (typeof window.gtag !== 'function') return;

			if (data && data.next && data.next.html) {
				const nextDocument = new DOMParser().parseFromString(data.next.html, 'text/html');

				if (nextDocument.title) document.title = nextDocument.title;
			}

			window.gtag('event', 'page_view', {
				page_title: document.title,
				page_location: window.location.href,
				page_path: data && data.next && data.next.url
					? data.next.url.path
					: window.location.pathname
			});
		},
		/** Barba page swap with a subtle full-screen fade. */
		initBarba: function() {
			var self = this;

			if (!document.querySelector('[data-barba="wrapper"]')) return;

			// Avoid conflicting with WordPress editor previews.
			if (document.body.classList.contains('wp-admin')) return;
			var overlay = document.querySelector('.js-page-transition');

			var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			var fadeInDuration = reduceMotion ? 0.01 : 0.35;
			var fadeOutDuration = reduceMotion ? 0.01 : 0.5;

			barba.init({
				preventRunning: true,
				transitions: [{
					name: 'fade',
					once: function(data) {
						self.initPageScripts();
						self.refreshPageLayout();
						self.updateNavCurrentState(data && data.next && data.next.url ? data.next.url.path : window.location.pathname);

						if (data && data.next && data.next.namespace) {
							document.body.setAttribute('data-page', data.next.namespace);
						}
					},
					leave: function() {
						return gsap.timeline()
							.set(overlay, { autoAlpha: 0 })
							.to(overlay, {
								autoAlpha: 1,
								duration: fadeInDuration,
								ease: 'power1.inOut'
							});
					},
					afterLeave: function() {
						if (self.lenis) {
							self.lenis.scrollTo(0, { immediate: true });
						} else {
							window.scrollTo(0, 0);
						}
					},

					after: function() {
						return gsap.timeline()
							.to(overlay, {
								autoAlpha: 0,
								duration: fadeOutDuration,
								ease: 'power1.out'
							});
					},
					afterEnter: function(data) {
						// Remove triggers tied to the page Barba just replaced.
						ScrollTrigger.getAll().forEach(function(trigger) {
							trigger.kill();
						});

						self.resetInviewAnimations();
						self.initPageScripts();
						self.refreshPageLayout();
						self.updateNavCurrentState(data && data.next && data.next.url ? data.next.url.path : window.location.pathname);

						if (data && data.next && data.next.namespace) {
							document.body.setAttribute('data-page', data.next.namespace);
						}

						self.trackAnalyticsPageView(data);
					}
				}]
			});
		},
		/** Keep the persistent mobile menu's current-page state in sync with Barba. */
		updateNavCurrentState: function(pathname) {
			const mobileMenu = document.querySelector('.js-nav-mobile');

			if (!mobileMenu) return;

			const normalisePath = function(path) {
				const decodedPath = decodeURIComponent(path || '/').replace(/\/index\.php$/, '');

				return decodedPath.length > 1 ? decodedPath.replace(/\/$/, '') : decodedPath;
			};
			const currentPath = normalisePath(pathname || window.location.pathname);

			mobileMenu.querySelectorAll('a').forEach(function(link) {
				const item = link.closest('li');
				let isCurrent = false;

				try {
					const url = new URL(link.href, window.location.origin);

					isCurrent = url.origin === window.location.origin && normalisePath(url.pathname) === currentPath;
				}
				catch (error) {
					isCurrent = false;
				}

				link.removeAttribute('aria-current');

				if (item) {
					item.classList.remove('current-menu-item', 'current_page_item', 'current-menu-ancestor', 'current_page_ancestor');
					item.classList.toggle('is-current-page', isCurrent);
				}

				if (isCurrent) link.setAttribute('aria-current', 'page');
			});
		},
		/**
		 * Letter-by-letter colour reveal with punctuation-aware pacing.
		 *
		 * Add `.js-text-reveal` to the parent wrapping one or more copy
		 * blocks (p, li, h1-h4...). Each block is split into chars via
		 * GSAP SplitText; characters sit at #838383 and "fill" to #fff
		 * when the block enters the viewport. Add
		 * `.js-text-reveal--cinematic` for natural reading speed and
		 * punctuation pauses; the base class keeps the original quick stagger.
		 *
		 */
		textReveal: function() {
			const wrappers = document.querySelectorAll('.js-text-reveal');

			if (!wrappers.length) return;

			// Respect reduced-motion: leave text at its resting (CSS) colour.
			if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
				wrappers.forEach(function(wrapper) {
					wrapper.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6').forEach(function(textEl) {
						gsap.set(textEl, { color: '#fff' });
					});
				});
				return;
			}

			wrappers.forEach(function(wrapper) {
				const isCinematic = wrapper.classList.contains('js-text-reveal--cinematic');
				const targets = wrapper.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6');
				const textEls = targets.length ? Array.from(targets) : [wrapper];

				textEls.forEach(function(textEl) {
					if (isCinematic && window.matchMedia('(min-width: 800px)').matches) {
						const copy = textEl.textContent.trim().replace(/\s+/g, ' ');
						const commaParts = copy.split(/,\s*/);
						const lines = [];

						commaParts.forEach(function(part, index) {
							const isLastPart = index === commaParts.length - 1;
							const line = isLastPart ? part : part + ',';

							// The final clause has one additional deliberate cinematic break.
							if (isLastPart) {
								const finalParts = line.split(/\s+(?=to stand\b)/i);
								lines.push.apply(lines, finalParts);
							} else {
								lines.push(line);
							}
						});

						textEl.replaceChildren();
						lines.forEach(function(line, index) {
							const lineEl = document.createElement('span');
							lineEl.textContent = line;
							textEl.appendChild(lineEl);

							if (index < lines.length - 1) {
								textEl.appendChild(document.createElement('br'));
							}
						});
					}

					const split = SplitText.create(textEl, {
						type: 'words, chars',
						wordsClass: 'text-reveal__word',
						charsClass: 'text-reveal__char'
					});

					if (!split.chars.length) return;

					gsap.set(split.chars, {
						color: '#333'
					});

					if (!isCinematic) {
						gsap.to(split.chars, {
							color: '#fff',
							duration: 0.2,
							ease: 'power2.out',
							stagger: {
								amount: 0.55
							},
							scrollTrigger: {
								trigger: textEl,
								start: 'top 85%',
								once: true
							}
						});
						return;
					}

					// A fixed cadence keeps the reveal close to a natural reading pace;
					// longer passages now take proportionally longer instead of being
					// compressed into the same short stagger duration.
					const characterGap = 0.022;
					const reveal = gsap.timeline({
						scrollTrigger: {
							trigger: textEl,
							start: 'top 85%',
							once: true
						}
					});

					let position = 0;

					split.chars.forEach(function(char) {
						reveal.to(char, {
							color: '#fff',
							duration: 0.4,
							ease: 'power2.out'
						}, position);

						position += characterGap;

						const character = char.textContent.trim();

						if (/[.!?]/.test(character)) {
							position += 0.65;
						} else if (/[,;:]/.test(character)) {
							position += 0.38;
						}
					});
				});
			});
		},
		/**
		 * Cinematic angled title reveal — split lines/words/chars.
		 *
		 * Two classes, same reveal:
		 *   .js-title-reveal          full effect, including the blur-in on
		 *                              each char/word. Built for big display
		 *                              titles — the blur is what sells the
		 *                              "cinematic" read at that scale.
		 *   .js-title-smaller-reveal  identical blade/clip/rise/stagger, but
		 *                              WITHOUT the blur. At smaller sizes the
		 *                              blur reads as soft/muddy rather than
		 *                              cinematic (and costs more to
		 *                              composite) — use this for subheads,
		 *                              card titles, anything under roughly
		 *                              display size.
		 *
		 * Add either class to any heading — or to a single word/span within
		 * one, useful for titles that are already hand-built out of several
		 * independently-positioned lines (see the three spans in
		 * page-hero-about.hbs). GSAP SplitText breaks whatever it's put on
		 * into lines, words AND chars; each line unclips from behind a
		 * diagonal "blade" while its characters rise into focus, staggered
		 * top-to-bottom / left-to-right. Plays once, the moment the title
		 * enters the viewport (ScrollTrigger `once: true`, no scrub) — never
		 * re-triggers, never tied to scroll position, per the brief. Reduced
		 * motion skips the split/animation machinery entirely and just shows
		 * the title.
		 *
		 * Optional per-element data attributes (both classes):
		 *   data-title-reveal-angle="10"    steepness of the diagonal wipe,
		 *                                    as a % of line-height. Negative
		 *                                    flips which way it leans.
		 *   data-title-reveal-split="words" animate whole words instead of
		 *                                    chars — calmer and more
		 *                                    restrained, better for very
		 *                                    large / short headlines.
		 *   data-title-reveal-line-height="1"
		 *                                    disables the built-in line
		 *                                    tightening (default 0.8) for
		 *                                    multi-line titles — see the
		 *                                    comment above the line-height
		 *                                    block below for why this is a
		 *                                    JS margin trick rather than
		 *                                    just setting CSS line-height.
		 *   data-title-reveal-delay="0.15"  extra seconds before this
		 *                                    element's own timeline plays
		 *                                    once triggered — use this to
		 *                                    choreograph several
		 *                                    `.js-title-reveal` elements
		 *                                    that make up one composite
		 *                                    title (one per line/span) into
		 *                                    a single cascading reveal.
		 *
		 */
		titleReveal: function() {
			const self = this;
			const largeTitles = document.querySelectorAll('.js-title-reveal');
			const smallerTitles = document.querySelectorAll('.js-title-smaller-reveal');

			if (!largeTitles.length && !smallerTitles.length) return;

			const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

			const initTitle = function(title, withBlur) {
				if (reduceMotion) {
					gsap.set(title, { autoAlpha: 1 });
					return;
				}

				self.animateTitleReveal(title, withBlur);
			};

			largeTitles.forEach(function(title) {
				initTitle(title, true);
			});

			smallerTitles.forEach(function(title) {
				initTitle(title, false);
			});
		},
		/**
		 * Builds and arms a single title-reveal element. Split out from
		 * titleReveal() so it can be called on one title at a time (each
		 * gets its own SplitText instance, timeline and ScrollTrigger).
		 *
		 * @param {Element} title
		 * @param {boolean} withBlur - false for .js-title-smaller-reveal;
		 *                             everything else about the reveal is
		 *                             identical either way.
		 *
		 */
		animateTitleReveal: function(title, withBlur) {
			// Guards against double-init if initPageScripts ever runs twice
			// for the same DOM node within one page. Not a concern across
			// Barba transitions — the previous page's nodes are gone by then.
			if (title.dataset.titleRevealInit) return;
			title.dataset.titleRevealInit = 'true';

			// Hide immediately - before fonts/split are even ready - so
			// there's no flash of plain, unsplit text. Restored the instant
			// every line/char has its own hidden state applied below, so
			// nothing pops once it's visible.
			gsap.set(title, { autoAlpha: 0 });

			const run = function() {
				const split = SplitText.create(title, {
					type: 'lines, words, chars',
					linesClass: 'title-reveal__line',
					wordsClass: 'title-reveal__word',
					charsClass: 'title-reveal__char'
				});

				if (!split.chars.length) {
					gsap.set(title, { autoAlpha: 1 });
					return;
				}

				const angleAttr = parseFloat(title.dataset.titleRevealAngle);
				const angle = Number.isNaN(angleAttr) ? 10 : angleAttr;
				const delay = parseFloat(title.dataset.titleRevealDelay) || 0;
				const useWords = title.dataset.titleRevealSplit === 'words';
				const units = useWords ? split.words : split.chars;

				/*
				 * Visual line-height tightening — done here in JS, not CSS.
				 *
				 * Each line's own box has to stay at its natural CSS
				 * line-height (1, see h1-h6 in _typography.scss) so the
				 * clip-path below has room for the full glyph — ascenders,
				 * descenders, the lot — without slicing it off. Shrinking
				 * that box with CSS line-height re-introduces exactly that
				 * clipping (that's why the reveal only looked right at
				 * line-height: 1). Instead every line keeps its full box
				 * and gets pulled up toward the one above it with a
				 * negative margin sized off its own measured height, so
				 * only the GAP between lines closes up, never the box the
				 * clip-path relies on.
				 *
				 * data-title-reveal-line-height="1" disables this (no
				 * tightening) on a given title; any value below 1 pulls
				 * lines closer, e.g. 0.8 for a noticeably tighter stack.
				 */
				const lineHeightAttr = parseFloat(title.dataset.titleRevealLineHeight);
				const lineHeightRatio = Number.isNaN(lineHeightAttr) ? 0.8 : lineHeightAttr;

				if (split.lines.length > 1 && lineHeightRatio !== 1) {
					split.lines.forEach(function(line, index) {
						if (index === 0) return;

						const tighten = line.offsetHeight * (1 - lineHeightRatio);

						gsap.set(line, { marginTop: -tighten });
					});
				}

				/*
				 * Diagonal "blade" clip-path.
				 *
				 * hiddenClip's moving corner sits at 0% (top) and -angle%
				 * (bottom) — both animate to 100% in shownClip. Because
				 * they start at different x offsets but land on the same
				 * value, they're out of step with each other mid-tween;
				 * that gap between the top and bottom edge IS the angled
				 * blade sweeping across. They arrive back in step (a plain
				 * rectangle) exactly as the tween completes.
				 */
				const hiddenClip = `polygon(0% 0%, 0% 0%, ${-angle}% 100%, 0% 100%)`;
				const shownClip = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';

				gsap.set(split.lines, {
					clipPath: hiddenClip
				});

				// Blur is what makes the large reveal feel "cinematic", but
				// at smaller sizes it just reads as soft focus and costs
				// more to composite for no visual gain — .js-title-smaller-
				// reveal (withBlur: false) drops it, everything else about
				// the hidden/shown state stays identical.
				const unitsHiddenState = {
					yPercent: 130,
					rotateZ: angle * 0.45,
					autoAlpha: 0,
					transformOrigin: '50% 100%'
				};

				if (withBlur) {
					unitsHiddenState.filter = 'blur(16px)';
				}

				gsap.set(units, unitsHiddenState);

				gsap.set([split.lines, units], {
					willChange: withBlur ? 'clip-path, transform, filter, opacity' : 'clip-path, transform, opacity'
				});

				// Wrapper can come back now - its children are each already
				// sitting in their own hidden state above.
				gsap.set(title, { autoAlpha: 1 });

				const tl = gsap.timeline({
					paused: true,
					delay: delay,
					defaults: { ease: 'power4.out' },

					onComplete: function() {
						// Nothing left to animate - drop the clip-path (one
						// less thing for the browser to keep compositing)
						// and release will-change.
						gsap.set(split.lines, { clipPath: 'none' });
						gsap.set([split.lines, units], { willChange: 'auto' });
					}
				});

				// The blade: each line unclips left-to-right, lines
				// themselves staggered top-to-bottom.
				tl.to(split.lines, {
					clipPath: shownClip,
					duration: 1.15,
					ease: 'power4.inOut',
					stagger: 0.13
				}, 0);

				// The detail: chars (or whole words) rise into focus (out of
				// a blur, on .js-title-reveal), slightly overlapping the
				// blade so letters resolve as the wipe passes over them
				// rather than after.
				const unitsShownState = {
					yPercent: 0,
					rotateZ: 0,
					autoAlpha: 1,
					duration: 1.05,
					ease: 'expo.out',

					stagger: {
						each: useWords ? 0.05 : 0.018,
						from: 'start'
					}
				};

				if (withBlur) {
					unitsShownState.filter = 'blur(0px)';
				}

				tl.to(units, unitsShownState, 0.1);

				// Exposed as a plain property (not a data-* attribute — this
				// is a computed value for JS-to-JS use, not something an
				// author sets) so copyReveal() can time body copy to finish
				// just after this title does. Includes the timeline's own
				// `delay`, since that's real wall-clock time too.
				title.titleRevealDuration = tl.totalDuration();

				ScrollTrigger.create({
					trigger: title,
					start: 'top 85%',
					once: true,

					onEnter: function() {
						tl.play();
					}
				});
			};

			// Split after webfonts land, so line breaks (and therefore the
			// per-line clip-path/stagger) are measured against the real
			// title font rather than a fallback. 2s safety timeout in case
			// fonts.ready never resolves (rare, but a title stuck invisible
			// forever is worse than one split a beat early).
			if (document.fonts && document.fonts.status !== 'loaded') {
				let hasRun = false;

				const runOnce = function() {
					if (hasRun) return;
					hasRun = true;
					run();
				};

				document.fonts.ready.then(runOnce);
				setTimeout(runOnce, 2000);
			} else {
				run();
			}
		},
		/**
		 * Simple fade-up for body copy, timed to land just after a nearby
		 * title-reveal finishes rather than fading in on its own.
		 *
		 * Add `.js-copy-reveal` to a paragraph (or any wrapper — everything
		 * inside fades/rises together as one block). It still gets its own
		 * ScrollTrigger (`once: true`, no scrub — same "plays once on
		 * viewport entry" rule as the titles), but the actual fade is
		 * additionally delayed until whichever `.js-title-reveal` /
		 * `.js-title-smaller-reveal` element it's paired with has (almost)
		 * finished its own reveal, so the copy is never sitting there fully
		 * legible while the title is still animating above it.
		 *
		 * Pairing is automatic: it walks up from the copy element to the
		 * nearest ancestor that also contains a title-reveal element, and
		 * targets every one found inside it — which is exactly how these
		 * two are marked up together in practice (one shared header/wrapper,
		 * see .page-hero-about__header in page-hero-about.hbs). Override
		 * with `data-copy-reveal-target` when the title lives somewhere
		 * else in the DOM. No paired title found (or none yet revealed) is
		 * a valid, ordinary case — the copy just fades in on its own.
		 *
		 * Optional per-element data attributes:
		 *   data-copy-reveal-target="#hero-title"
		 *                                    CSS selector for the title(s)
		 *                                    to wait on, overriding the
		 *                                    automatic nearest-ancestor
		 *                                    pairing above.
		 *   data-copy-reveal-overlap="0.3"  seconds to start BEFORE the
		 *                                    paired title's reveal fully
		 *                                    completes, so the two overlap
		 *                                    slightly instead of leaving a
		 *                                    dead pause ("just about" done,
		 *                                    per the brief). Default 0.3.
		 *   data-copy-reveal-delay="0.2"    extra flat seconds added on top
		 *                                    of the above — for staggering
		 *                                    several copy blocks under the
		 *                                    same title.
		 *
		 */
		copyReveal: function() {
			const self = this;
			const copies = document.querySelectorAll('.js-copy-reveal');

			if (!copies.length) return;

			const run = function() {
				copies.forEach(function(copy) {
					self.animateCopyReveal(copy);
				});
			};

			// Same wait-for-fonts approach as titleReveal(), and crucially
			// registered AFTER it: titleReveal() has already queued every
			// title's own fonts.ready callback by the time this one gets
			// added, so — same promise, callbacks fire in registration
			// order — every title's timeline (and its titleRevealDuration)
			// is already built by the time this runs.
			if (document.fonts && document.fonts.status !== 'loaded') {
				let hasRun = false;

				const runOnce = function() {
					if (hasRun) return;
					hasRun = true;
					run();
				};

				document.fonts.ready.then(runOnce);
				setTimeout(runOnce, 2000);
			} else {
				run();
			}
		},
		/**
		 * Builds and arms a single .js-copy-reveal element. Split out from
		 * copyReveal() so it can be called on one block at a time.
		 *
		 */
		animateCopyReveal: function(copy) {
			if (copy.dataset.copyRevealInit) return;
			copy.dataset.copyRevealInit = 'true';

			if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
				gsap.set(copy, { autoAlpha: 1 });
				return;
			}

			const targetSelector = copy.dataset.copyRevealTarget;
			let titles = [];

			if (targetSelector) {
				titles = Array.from(document.querySelectorAll(targetSelector));
			} else {
				let ancestor = copy.parentElement;

				while (ancestor && ancestor !== document.body) {
					const found = ancestor.querySelectorAll('.js-title-reveal, .js-title-smaller-reveal');

					if (found.length) {
						titles = Array.from(found);
						break;
					}

					ancestor = ancestor.parentElement;
				}
			}

			// Longest-running paired title wins - the copy waits for all of
			// them, not just the first to finish.
			const titleDuration = titles.reduce(function(longest, title) {
				return Math.max(longest, title.titleRevealDuration || 0);
			}, 0);

			const overlapAttr = parseFloat(copy.dataset.copyRevealOverlap);
			const overlap = Number.isNaN(overlapAttr) ? 0.3 : overlapAttr;
			const extraDelay = parseFloat(copy.dataset.copyRevealDelay) || -0.2;
			const delay = Math.max(0, titleDuration - overlap) + extraDelay;

			gsap.set(copy, {
				autoAlpha: 0,
				y: 16
			});

			ScrollTrigger.create({
				trigger: copy,
				start: 'top 90%',
				once: true,

				onEnter: function() {
					gsap.to(copy, {
						autoAlpha: 1,
						y: 0,
						duration: 0.9,
						ease: 'power2.out',
						delay: delay
					});
				}
			});
		},
		/**
		 * Infinite right-to-left partner logo marquee.
		 *
		 * Expects .js-partners-marquee > .js-partners-group containing two
		 * (identical) .partners__track lists (see partners.hbs). The group
		 * is translated -50% on a linear, non-stop loop — since the second
		 * track is a duplicate of the first, the loop reads as seamless.
		 * Speed is distance-based (px/second) so it stays consistent
		 * however many logos end up in the strip. It runs continuously at a
		 * constant speed and becomes a static row for reduced motion.
		 *
		 */
		partnersMarquee: function() {
			const marquees = document.querySelectorAll('.js-partners-marquee');

			if (!marquees.length) return;

			const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

			marquees.forEach(function(marquee) {
				const group = marquee.querySelector('.js-partners-group');
				const track = group ? group.querySelector('.partners__track') : null;

				if (!group || !track) return;

				// Reduced motion: keep one static row, drop the aria-hidden duplicate.
				if (reduceMotion) {
					const duplicate = group.querySelectorAll('.partners__track')[1];

					if (duplicate) duplicate.remove();

					return;
				}

				const pxPerSecond = 60;

				let anim;
				let resizeTimer;

				const play = function() {
					const distance = track.getBoundingClientRect().width;
					const duration = distance / pxPerSecond;

					if (anim) anim.kill();

					gsap.set(group, {
						xPercent: 0
					});

					anim = gsap.to(group, {
						xPercent: -50,
						duration: duration,
						ease: 'none',
						repeat: -1
					});
				};

				play();

				window.addEventListener('resize', function() {
					clearTimeout(resizeTimer);
					resizeTimer = setTimeout(play, 200);
				});
			});
		},
		nav: function() {
			const self = this;
			const nav = document.querySelector('.js-nav');
			const toggle = document.querySelector('.js-nav-toggle');
			const mobileMenu = document.querySelector('.js-nav-mobile');

			if (!nav) return;

			self.updateNavCurrentState(window.location.pathname);

			let lastScrollY = window.scrollY;
			let ticking = false;
			let menuOpen = false;

			const showNav = function() {
				nav.classList.remove('is-hidden');
			};

			const hideNav = function() {
				if (menuOpen) return;
				nav.classList.add('is-hidden');
			};

			const openMenu = function() {
				if (!toggle || !mobileMenu) return;

				menuOpen = true;

				nav.classList.add('is-menu-open');
				nav.classList.remove('is-hidden');

				document.body.classList.add('nav-is-open');

				toggle.setAttribute('aria-expanded', 'true');
				toggle.setAttribute('aria-label', toggle.dataset.closeLabel || 'Close menu');

				mobileMenu.setAttribute('aria-hidden', 'false');
			};

			const closeMenu = function() {
				if (!toggle || !mobileMenu) return;

				menuOpen = false;

				nav.classList.remove('is-menu-open');
				document.body.classList.remove('nav-is-open');

				toggle.setAttribute('aria-expanded', 'false');
				toggle.setAttribute('aria-label', toggle.dataset.openLabel || 'Open menu');

				mobileMenu.setAttribute('aria-hidden', 'true');
			};

			const toggleMenu = function() {
				if (menuOpen) {
					closeMenu();
				} else {
					openMenu();
				}
			};

			const updateNav = function() {
				const currentScrollY = window.scrollY;
				const delta = currentScrollY - lastScrollY;

				if (menuOpen) {
					lastScrollY = currentScrollY;
					ticking = false;
					return;
				}

				// Always show near top of page
				if (currentScrollY <= 20) {
					showNav();
				}
				// Ignore tiny trackpad / touch movements
				else if (Math.abs(delta) > 6) {
					if (delta > 0) {
						hideNav();
					} else {
						showNav();
					}
				}

				lastScrollY = currentScrollY;
				ticking = false;
			};

			const onScroll = function() {
				if (ticking) return;

				ticking = true;

				window.requestAnimationFrame(updateNav);
			};

			if (toggle) {
				toggle.addEventListener('click', toggleMenu);
			}

			if (mobileMenu) {
				mobileMenu.querySelectorAll('a').forEach(function(link) {
					link.addEventListener('click', closeMenu);
				});
			}

			document.addEventListener('keydown', function(event) {
				if (event.key === 'Escape' && menuOpen) {
					closeMenu();

					if (toggle) {
						toggle.focus();
					}
				}
			});

			window.addEventListener('scroll', onScroll, {
				passive: true
			});

			window.addEventListener('resize', function() {
				if (window.innerWidth >= 800 && menuOpen) {
					closeMenu();
				}
			});
		},
		pageHeroHomepage: function(elt) {
			const self = this;
			const root = typeof elt === 'string'
				? document.querySelector(elt)
				: elt;

			if (!root || root.dataset.heroInitialized === 'true') return;

			const background = root.querySelector('.js-homepage-hero-background');
			const featureBackground = root.querySelector('.js-homepage-hero-background-feature');
			const content = root.querySelector('.page-hero-homepage__content');
			const logoMask = root.querySelector('.page-hero-homepage__logo-mask');
			const logo = root.querySelector('.js-homepage-hero-logo');
			const copyLeft = root.querySelector('.js-homepage-hero-copy-left');
			const copyRight = root.querySelector('.js-homepage-hero-copy-right');
			const explore = root.querySelector('.js-homepage-hero-explore');
			const gallery = root.querySelector('.js-homepage-hero-gallery');
			const galleryCards = Array.from(root.querySelectorAll('.js-homepage-hero-card'));
			const centerCard = root.querySelector('.js-homepage-hero-card-center');

			if (!background || !featureBackground || !content || !logoMask || !logo || !copyLeft || !copyRight || !explore || !gallery || !centerCard || galleryCards.length !== 5) return;

			root.dataset.heroInitialized = 'true';

			const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			const initialWordGap = Math.min(110, window.innerWidth * .065);
			const finalWordGap = window.innerWidth < 800
				? 6
				: Math.min(18, Math.max(8, window.innerWidth * .009));
			const transitionWordGap = Math.min(48, finalWordGap * 2);
			const initialLogoWidth = logoMask.getBoundingClientRect().width;
			const finalLogoWidth = initialLogoWidth * .63;
			const isMobile = window.innerWidth < 800;
			const galleryLayout = {
				'far-left': {
					x: isMobile ? '-68vw' : '-55vw', y: isMobile ? '-2vh' : '-1vh', z: -220,
					rotationY: 0, width: isMobile ? '42vw' : '25vw', height: isMobile ? '62vh' : '82vh'
				},
				'near-left': {
					x: isMobile ? '-39vw' : '-35vw', y: isMobile ? '2vh' : '2vh', z: -70,
					rotationY: 4, width: isMobile ? '42vw' : '22vw', height: isMobile ? '52vh' : '58vh'
				},
				center: {
					x: 0, y: 0, z: 0, rotationY: 0,
					width: isMobile ? '92vw' : '34vw', height: isMobile ? '51.75vw' : '42vh'
				},
				'near-right': {
					x: isMobile ? '39vw' : '35vw', y: isMobile ? '2vh' : '2vh', z: -70,
					rotationY: -4, width: isMobile ? '42vw' : '22vw', height: isMobile ? '52vh' : '58vh'
				},
				'far-right': {
					x: isMobile ? '68vw' : '55vw', y: isMobile ? '-2vh' : '-1vh', z: -220,
					rotationY: 0, width: isMobile ? '42vw' : '25vw', height: isMobile ? '62vh' : '82vh'
				}
			};
			const sideCards = galleryCards.filter(function(card) {
				return card !== centerCard;
			});
			const galleryImages = galleryCards.map(function(card) {
				return card.querySelector('img');
			});

			const scrollToContent = function(event) {
				const target = document.querySelector(event.currentTarget.getAttribute('href'));

				if (!target) return;

				event.preventDefault();

				if (self.lenis) {
					self.lenis.scrollTo(target, {
						duration: 2
					});
				}
				else {
					target.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}
			};

			explore.addEventListener('click', scrollToContent);

			if (reduceMotion) {
				gsap.set([background, featureBackground, content, logoMask, logo, copyLeft, copyRight, explore, gallery].concat(galleryCards), {
					clearProps: 'all'
				});
				gsap.set([background, featureBackground, logoMask, copyLeft, copyRight, explore], { autoAlpha: 0 });
				gsap.set(gallery, { autoAlpha: 1 });
				gsap.set(explore, { autoAlpha: 1 });
				galleryCards.forEach(function(card) {
					gsap.set(card, Object.assign({
						xPercent: -50,
						yPercent: -50,
						autoAlpha: 1
					}, galleryLayout[card.dataset.galleryPosition]));
				});
				return;
			}

			gsap.set(logo, {
				xPercent: -50,
				yPercent: -100
			});
			gsap.set(content, {
				clipPath: 'inset(0 0 0 0)'
			});
			gsap.set([copyLeft, logoMask, copyRight], {
				clipPath: 'inset(0 0 0 0)',
				filter: 'blur(0px)'
			});
			gsap.set(galleryCards, {
				xPercent: -50,
				yPercent: -50
			});
			gsap.set(galleryImages, {
				clipPath: 'inset(0 0 0 0)'
			});
			gsap.set(centerCard, {
				width: '100vw',
				height: '100svh',
				autoAlpha: 1
			});
			gsap.set(sideCards, {
				x: 0,
				y: 0,
				z: -480,
				scale: .62,
				autoAlpha: 0
			});

			const timeline = gsap.timeline({ defaults: { overwrite: 'auto' } })
				.fromTo(background, {
					filter: 'blur(48px)',
					scale: 1.16
				}, {
					filter: 'blur(0px)',
					scale: 1,
					duration: 1.5,
					ease: 'power2.inOut'
				})
				.fromTo(logo, {
					xPercent: -50,
					yPercent: 180,
					autoAlpha: 0
				}, {
					xPercent: -50,
					yPercent: -100,
					autoAlpha: 1,
					duration: 1.1,
					ease: 'power4.out'
				}, .45)
				.fromTo(copyLeft, {
					xPercent: -35,
					columnGap: initialWordGap,
					autoAlpha: 0
				}, {
					xPercent: 0,
					columnGap: transitionWordGap,
					autoAlpha: 1,
					duration: .95,
					ease: 'power3.out'
				}, 1.15)
				.fromTo(copyRight, {
					xPercent: 35,
					columnGap: initialWordGap,
					autoAlpha: 0
				}, {
					xPercent: 0,
					columnGap: transitionWordGap,
					autoAlpha: 1,
					duration: .95,
					ease: 'power3.out'
				}, 1.15)
				.to(background, {
					autoAlpha: 0,
					duration: 1.45,
					ease: 'power3.inOut'
				}, 2.2)
				.fromTo(featureBackground, {
					autoAlpha: 0,
					scale: 1.06
				}, {
					autoAlpha: 1,
					scale: 1,
					duration: 1.45,
					ease: 'power3.inOut'
				}, 2.2)
				.to(logoMask, {
					width: isMobile ? initialLogoWidth : 0,
					duration: 1.45,
					ease: 'power3.inOut'
				}, 2.2)
				.to(logo, {
					autoAlpha: isMobile ? 1 : 0,
					duration: .85,
					ease: 'power2.inOut'
				}, 2.2)
				.to(copyLeft, {
					columnGap: Math.max(4, finalWordGap * .55),
					paddingRight: isMobile ? 8 : 4,
					duration: 1.45,
					ease: 'power3.inOut'
				}, 2.2)
				.to(copyRight, {
					columnGap: Math.max(4, finalWordGap * .55),
					paddingLeft: isMobile ? 8 : 4,
					duration: 1.45,
					ease: 'power3.inOut'
				}, 2.2)
				.to(content, {
					autoAlpha: 0,
					filter: 'blur(14px)',
					scale: .96,
					duration: .75,
					ease: 'power3.inOut'
				}, 4.33)
				.set(gallery, { autoAlpha: 1 }, 4.36)
				.to(featureBackground, {
					autoAlpha: 0,
					duration: .45,
					ease: 'power2.inOut'
				}, 4.36)
				.to(centerCard, Object.assign({
					scale: 1,
					duration: 1.55,
					ease: 'power3.inOut'
				}, galleryLayout.center), 4.4);

			sideCards.forEach(function(card, index) {
				timeline.to(card, Object.assign({
					scale: 1,
					autoAlpha: 1,
					duration: 1.45,
					ease: 'power3.out'
				}, galleryLayout[card.dataset.galleryPosition]), 4.48 + (index * .07));
			});

			let carouselReady = false;
			let heroInView = true;
			let carouselMotion = null;
			let carouselDelay = null;
			let cardPositions = galleryCards.map(function(card) {
				return card.dataset.galleryPosition;
			});
			const nextPosition = {
				'far-left': 'far-right',
				'near-left': 'far-left',
				center: 'near-left',
				'near-right': 'center',
				'far-right': 'near-right'
			};
			const positionDepth = {
				'far-left': 1,
				'near-left': 2,
				center: 3,
				'near-right': 2,
				'far-right': 1
			};

			const scheduleCarousel = function() {
				carouselDelay = gsap.delayedCall(1.8, rotateCarousel);

				if (!heroInView) {
					carouselDelay.pause();
				}
			};

			const rotateCarousel = function() {
				const targetPositions = cardPositions.map(function(position) {
					return nextPosition[position];
				});
				const wrappingIndex = cardPositions.indexOf('far-left');
				const wrappingCard = galleryCards[wrappingIndex];

				carouselMotion = gsap.timeline({
					paused: !heroInView,
					defaults: { overwrite: 'auto' },
					onComplete: function() {
						cardPositions = targetPositions;
						scheduleCarousel();
					}
				})
					.to(wrappingCard, {
						autoAlpha: 0,
						scale: .9,
						duration: .28,
						ease: 'power2.in'
					})
					.set(wrappingCard, Object.assign({
						autoAlpha: 0,
						scale: .9,
						z: -360,
						zIndex: 0
					}, galleryLayout['far-right']))
					.addLabel('carouselMove')
					.to(galleryCards, {
						x: function(index) { return galleryLayout[targetPositions[index]].x; },
						y: function(index) { return galleryLayout[targetPositions[index]].y; },
						z: function(index) { return galleryLayout[targetPositions[index]].z; },
						rotationY: function(index) { return galleryLayout[targetPositions[index]].rotationY; },
						width: function(index) { return galleryLayout[targetPositions[index]].width; },
						height: function(index) { return galleryLayout[targetPositions[index]].height; },
						scale: 1,
						autoAlpha: 1,
						duration: 1.35,
						ease: 'power3.inOut'
					}, 'carouselMove')
					.set(galleryCards, {
						zIndex: function(index) {
							return positionDepth[targetPositions[index]];
						}
					}, 'carouselMove+=0.675');
			};

			const heroObserver = new IntersectionObserver(function(entries) {
				heroInView = entries[0].isIntersecting;

				if (!carouselReady) return;

				if (heroInView) {
					if (carouselMotion) carouselMotion.resume();
					if (carouselDelay) carouselDelay.resume();
				}
				else {
					if (carouselMotion) carouselMotion.pause();
					if (carouselDelay) carouselDelay.pause();
				}
			}, {
				threshold: .15
			});

			heroObserver.observe(root);
			timeline.eventCallback('onComplete', function() {
				carouselReady = true;

				if (heroInView) {
					scheduleCarousel();
				}
			});
		},
		videoReveal: function(config) {
			const root = config.root;
			const trigger = config.trigger;
			const source = config.source;
			const playButton = config.playButton;
			const content = config.content;
			const poster = config.poster;
			const iframeWrap = config.iframeWrap;

			if (!root || !trigger || !source || !playButton || !content || !poster || !iframeWrap) return;
			if (root.dataset.plyrInitialized === 'true' || !source.dataset.videoSrc) return;

			root.dataset.plyrInitialized = 'true';
			iframeWrap.replaceChildren();

			const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			const hasCursor = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
			let isPlaying = false;
			let revealTimeline = null;

			if (reduceMotion) poster.classList.add('is-inview');
			else {
				const posterObserver = new IntersectionObserver(function(entries) {
					if (!entries[0].isIntersecting) return;

					const hasClipReveal = Boolean(poster.closest('.ivanim-clip-reveal-test'));
					const posterFrom = {
						filter: 'blur(18px)'
					};
					const posterTo = {
						filter: 'blur(0px)',
						duration: 1.4,
						ease: 'power3.out',
						overwrite: 'auto'
					};

					if (!hasClipReveal) {
						posterFrom.scale = 1.08;
						posterTo.scale = 1;
					}

					poster.classList.add('is-inview');
					gsap.fromTo(poster, posterFrom, posterTo);
					posterObserver.disconnect();
				}, {
					threshold: .2
				});

				posterObserver.observe(root);
			}

			if (hasCursor) {
				let pointerX = null;
				let pointerY = null;
				let scrollFrame = null;
				const movePlayButtonX = gsap.quickTo(playButton, 'x', {
					duration: .45,
					ease: 'power3.out'
				});
				const movePlayButtonY = gsap.quickTo(playButton, 'y', {
					duration: .45,
					ease: 'power3.out'
				});
				const positionPlayButton = function(clientX, clientY) {
					const bounds = trigger.getBoundingClientRect();
					const buttonBounds = playButton.getBoundingClientRect();
					const currentX = Number(gsap.getProperty(playButton, 'x')) || 0;
					const currentY = Number(gsap.getProperty(playButton, 'y')) || 0;
					const restingX = buttonBounds.left + buttonBounds.width / 2 - currentX;
					const restingY = buttonBounds.top + buttonBounds.height / 2 - currentY;
					const edgeGap = 16;
					const cursorGap = 14;
					const halfWidth = buttonBounds.width / 2;
					const halfHeight = buttonBounds.height / 2;
					const fitsRight = clientX + buttonBounds.width + cursorGap + edgeGap <= bounds.right;
					const fitsBelow = clientY + buttonBounds.height + cursorGap + edgeGap <= bounds.bottom;
					const desiredX = clientX + (fitsRight ? halfWidth + cursorGap : -halfWidth - cursorGap);
					const desiredY = clientY + (fitsBelow ? halfHeight + cursorGap : -halfHeight - cursorGap);
					const targetX = gsap.utils.clamp(bounds.left + halfWidth + edgeGap, bounds.right - halfWidth - edgeGap, desiredX);
					const targetY = gsap.utils.clamp(bounds.top + halfHeight + edgeGap, bounds.bottom - halfHeight - edgeGap, desiredY);

					movePlayButtonX(targetX - restingX);
					movePlayButtonY(targetY - restingY);
				};
				const movePlayButton = function(event) {
					pointerX = event.clientX;
					pointerY = event.clientY;
					positionPlayButton(pointerX, pointerY);
				};
				const updatePlayButtonOnScroll = function() {
					scrollFrame = null;
					if (pointerX === null || pointerY === null || isPlaying) return;

					const bounds = trigger.getBoundingClientRect();
					const pointerIsOverTrigger = pointerX >= bounds.left
						&& pointerX <= bounds.right
						&& pointerY >= bounds.top
						&& pointerY <= bounds.bottom;

					if (pointerIsOverTrigger) positionPlayButton(pointerX, pointerY);
					else {
						movePlayButtonX(0);
						movePlayButtonY(0);
					}
				};
				const queuePlayButtonScrollUpdate = function() {
					if (scrollFrame !== null) return;
					scrollFrame = window.requestAnimationFrame(updatePlayButtonOnScroll);
				};

				trigger.addEventListener('pointerenter', movePlayButton);
				trigger.addEventListener('pointermove', movePlayButton);
				trigger.addEventListener('pointerleave', function() {
					movePlayButtonX(0);
					movePlayButtonY(0);
				});
				playButton.addEventListener('focus', function() {
					movePlayButtonX(0);
					movePlayButtonY(0);
				});
				window.addEventListener('scroll', queuePlayButtonScrollUpdate, { passive: true });
			}

			const playerElement = document.createElement('div');
			playerElement.dataset.plyrProvider = 'vimeo';
			playerElement.dataset.plyrEmbedId = source.dataset.videoSrc;
			if (source.dataset.videoHash) playerElement.dataset.plyrEmbedHash = source.dataset.videoHash;
			iframeWrap.appendChild(playerElement);

			const player = new Plyr(playerElement, {
				controls: ['play', 'progress', 'mute', 'volume'],
				muted: false,
				volume: 1,
				vimeo: { premium: true }
			});

			playButton.disabled = true;
			player.once('ready', function() {
				playButton.disabled = false;
			});

			const revealVideo = function() {
				playButton.setAttribute('aria-hidden', 'true');
				playButton.setAttribute('tabindex', '-1');

				if (reduceMotion) {
					root.classList.add('is-playing');
					return;
				}

				revealTimeline = gsap.timeline({
					onComplete: function() {
						root.classList.add('is-playing');
					}
				})
					.to(content, {
						yPercent: -6,
						autoAlpha: 0,
						filter: 'blur(6px)',
						duration: .5,
						ease: 'power3.in'
					})
					.to(poster, {
						scale: 1.08,
						autoAlpha: 0,
						duration: .9,
						ease: 'power2.inOut'
					}, '-=.25')
					.fromTo(iframeWrap, {
						autoAlpha: 0
					}, {
						autoAlpha: 1,
						duration: .6,
						ease: 'power2.out'
					}, '-=.5');
			};

			const playVideo = function() {
				if (isPlaying || playButton.disabled) return;

				isPlaying = true;
				playButton.disabled = true;
				player.muted = false;
				player.volume = 1;

				// Respond to the click immediately instead of waiting for Vimeo's
				// `playing` event. The iframe enters near the end of this timeline,
				// leaving playback a short head start without making the UI feel stuck.
				revealVideo();

				Promise.resolve(player.play()).catch(function() {
					isPlaying = false;
					playButton.disabled = false;
					playButton.removeAttribute('aria-hidden');
					playButton.removeAttribute('tabindex');
					root.classList.remove('is-playing');
					if (revealTimeline) revealTimeline.kill();
					gsap.set([content, poster, iframeWrap], { clearProps: 'all' });
				});
			};

			trigger.addEventListener('click', playVideo);
		},
		pageHeroAbout: function(elt) {
			const root = typeof elt === 'string' ? document.querySelector(elt) : elt;
			if (!root) return;

			const video = root.querySelector('.js-page-hero-video');

			this.videoReveal({
				root: root,
				trigger: video,
				source: video,
				playButton: root.querySelector('.js-page-hero-play'),
				content: root.querySelector('.js-page-hero-video-content'),
				poster: root.querySelector('.page-hero-about__poster'),
				iframeWrap: root.querySelector('.page-hero-about__iframe-wrap')
			});
		},
		showreel: function(elt) {
			const root = typeof elt === 'string' ? document.querySelector(elt) : elt;
			if (!root) return;

			this.videoReveal({
				root: root,
				trigger: root,
				source: root,
				playButton: root.querySelector('.js-showreel-play'),
				content: root.querySelector('.showreel__content'),
				poster: root.querySelector('.showreel__poster'),
				iframeWrap: root.querySelector('.showreel__iframe-wrap')
			});
		},
		awards: function(elt) {
			const root = typeof elt === 'string'
				? document.querySelector(elt)
				: elt;

			if (!root) return;

			const awards = root.querySelectorAll('.js-award');

			if (!awards.length) return;

			const mm = gsap.matchMedia();

			const prepareAward = function(award) {
				const value = parseInt(award.dataset.value, 10);
				const number = award.querySelector('.awards__number-value');

				if (!number || Number.isNaN(value)) {
					return;
				}

				number.textContent = '0';
			};

			const addAwardAnimation = function(tl, award, position) {
				const value = parseInt(award.dataset.value, 10);
				const number = award.querySelector('.awards__number-value');

				if (!number || Number.isNaN(value)) {
					return;
				}

				const counter = {
					value: 0
				};
				const countDuration = gsap.utils.clamp(
					.65,
					1.2,
					.5 + (.7 * Math.sqrt(value / 50))
				);

				prepareAward(award);

				// Award enters
				tl.fromTo(
					award,
					{
						x: 40,
						opacity: 0
					},
					{
						x: 0,
						opacity: 1,
						duration: .45,
						ease: 'power3.out'
					},
					position
				);

				// Count up
				tl.to(
					counter,
					{
						value: value,
						duration: countDuration,
						ease: 'power2.out',

						onUpdate: function() {
							number.textContent = Math.round(counter.value);
						},

						onComplete: function() {
							number.textContent = value;
						}
					},
					position + .1
				);
			};

			// Desktop
			mm.add('(min-width: 800px)', () => {
				gsap.set(awards, {
					opacity: 0,
					x: 40
				});

				awards.forEach(function(award) {
					prepareAward(award);
				});

				const trigger = ScrollTrigger.create({
					trigger: root,
					start: 'top 70%',
					once: true,

					onEnter: function() {
						const tl = gsap.timeline();

						awards.forEach(function(award, index) {
							addAwardAnimation(
								tl,
								award,
								index * 1.15
							);
						});
					}
				});

				return () => {
					trigger.kill();
				};
			});

			// Mobile
			mm.add('(max-width: 799px)', () => {
				const triggers = [];

				awards.forEach(function(award) {
					prepareAward(award);

					gsap.set(award, {
						opacity: 0,
						x: 25
					});

					const trigger = ScrollTrigger.create({
						trigger: award,
						start: 'top 80%',
						once: true,

						onEnter: function() {
							const tl = gsap.timeline();

							addAwardAnimation(
								tl,
								award,
								0
							);
						}
					});

					triggers.push(trigger);
				});

				return () => {
					triggers.forEach(function(trigger) {
						trigger.kill();
					});
				};
			});
		},
		stackingSteps: function(elt) {
			const root = typeof elt === 'string'
				? document.querySelector(elt)
				: elt;

			if (!root) return;

			const introSlot = root.querySelector('.stacking-steps__slot--intro');
			const intro = root.querySelector('.stacking-steps__panel--intro');
			const stepSlots = Array.from(root.querySelectorAll('.stacking-steps__slot--step'));
			const endSpacer = root.querySelector('.stacking-steps__end');

			if (!introSlot || !intro || !stepSlots.length) return;

			const setIntegerStepHeights = function() {
				const isDesktop = window.innerWidth >= 800;
				const stepHeight = isDesktop ? `${Math.ceil(window.innerHeight / 2)}px` : '';

				stepSlots.forEach(function(slot) {
					const panel = slot.querySelector('.stacking-steps__step');

					slot.style.height = stepHeight;
					if (panel) panel.style.height = stepHeight;
				});

				if (endSpacer) endSpacer.style.height = stepHeight;
			};

			// 50vh can resolve to a half pixel (for example 451.5px), which
			// produces an antialiased seam when ScrollTrigger pins the panel.
			setIntegerStepHeights();

			gsap.set(intro, { zIndex: 1 });
			ScrollTrigger.create({
				trigger: introSlot,
				start: 'top top',
				endTrigger: root,
				end: 'bottom bottom',
				pin: intro,
				pinSpacing: false,
				anticipatePin: 1,
				invalidateOnRefresh: true,
				onRefreshInit: setIntegerStepHeights,
				id: 'stacking-intro'
			});

			stepSlots.forEach(function(slot, index) {
				const panel = slot.querySelector('.stacking-steps__step');

				if (!panel) return;

				gsap.set(panel, { zIndex: index + 2 });
				ScrollTrigger.create({
					trigger: slot,
					start: function() {
						return window.innerWidth >= 800 ? 'top 50%' : 'top top';
					},
					endTrigger: root,
					end: 'bottom bottom',
					pin: panel,
					pinSpacing: false,
					anticipatePin: 1,
					invalidateOnRefresh: true,
					onRefreshInit: setIntegerStepHeights,
					id: `stacking-step-${index + 1}`
				});
			});

		},
		initTextSliders: function () {
			const sliders = document.querySelectorAll('.js-text-slider');

			if (!sliders.length) return;

			const autoplayDuration = 5000;

			sliders.forEach((slider) => {
				const swiperEl = slider.querySelector('.swiper');
				const paginationEl = slider.querySelector('.swiper-pagination');

				if (!swiperEl) return;

				const totalSlides = swiperEl.querySelectorAll('.swiper-slide').length;

				slider.style.setProperty('--slider-duration', `${autoplayDuration}ms`);

				if (totalSlides <= 1) {
					slider.classList.add('is-single-slide');
				}

				const textSwiper = new Swiper(swiperEl, {
					modules: [Pagination, A11y, Keyboard, Autoplay, EffectFade],
					slidesPerView: 1,
					loop: totalSlides > 1,
					speed: 700,
					effect: 'fade',
					fadeEffect: {
						crossFade: true
					},
					autoplay: totalSlides > 1 ? {
						delay: autoplayDuration,
						disableOnInteraction: false,
						pauseOnMouseEnter: false
					} : false,
					keyboard: {
						enabled: true
					},
					a11y: {
						enabled: true
					},
					pagination: totalSlides > 1 ? {
						el: paginationEl,
						clickable: true,
						renderBullet(index, className) {
							return `<button class="${className}" type="button" aria-label="Go to slide ${index + 1}"></button>`;
						}
					} : false
				});

				if (totalSlides <= 1 || !textSwiper.autoplay) return;

				// Swiper starts autoplay during construction. Stop it immediately so
				// no time elapses before the slider actually reaches the viewport.
				textSwiper.autoplay.stop();

				if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

				const sliderObserver = new IntersectionObserver(function(entries) {
					if (entries[0].isIntersecting) {
						slider.classList.add('is-autoplaying');
						textSwiper.autoplay.start();
					}
					else {
						slider.classList.remove('is-autoplaying');
						textSwiper.autoplay.stop();
					}
				}, {
					threshold: .2
				});

				sliderObserver.observe(slider);
			});
		},
		/**
		 * Homepage "Latest" section — a Swiper slider of project cards
		 * (used at every breakpoint, not just mobile, so a 5th+ project
		 * can be added later without a layout rebuild) plus an independent
		 * open/close toggle per card. "Independent" is the key word: this
		 * is not an accordion, so opening one card's copy never closes
		 * another's — each card tracks its own .is-open state.
		 *
		 */
		initLatestProject: function() {
			const sliders = document.querySelectorAll('.js-latest-project-slider');

			if (!sliders.length) return;

			sliders.forEach((slider) => {
				const swiperEl = slider.querySelector('.swiper');
				const prevEl = slider.querySelector('.js-latest-project-prev');
				const nextEl = slider.querySelector('.js-latest-project-next');

				if (!swiperEl || slider.dataset.latestProjectInitialized === 'true') return;

				// Page setup can run again after transitions or layout refreshes.
				// Mark this DOM instance before binding so one click cannot be handled twice.
				slider.dataset.latestProjectInitialized = 'true';

				// Keep card controls independent from Swiper's click suppression.
				slider.addEventListener('click', function(event) {
					const toggle = event.target.closest('.js-latest-project-toggle');

					if (!toggle || !slider.contains(toggle)) return;

					const card = toggle.closest('.js-latest-project-card');

					if (!card) return;

					const isOpen = card.classList.toggle('is-open');
					const copyScroller = card.querySelector('.latest-project-card__copy-inner');

					toggle.setAttribute('aria-expanded', String(isOpen));
					if (copyScroller) copyScroller.setAttribute('tabindex', isOpen ? '0' : '-1');
				}, true);

				new Swiper(swiperEl, {
					modules: [A11y, Keyboard, Controller],
					noSwipingSelector: '.js-latest-project-toggle, .latest-project-card__copy-inner',
					preventClicks: false,
					preventClicksPropagation: false,
					slidesPerView: 1.15,
					spaceBetween: 16,
					watchOverflow: true,
					a11y: {
						enabled: true
					},
					keyboard: {
						enabled: true
					},
					// navigation: {
					// 	prevEl: prevEl,
					// 	nextEl: nextEl
					// },
					breakpoints: {
						650: {
							slidesPerView: 2.2,
							spaceBetween: 16
						},
						1024: {
							slidesPerView: 3.2,
							spaceBetween: 16
						},
						1024: {
							slidesPerView: 3.2,
							spaceBetween: 16
						},
						1440: {
							slidesPerView: 4,
							spaceBetween: 16
						}
					}
				});
			});
		},
		projectList: function(elt) {
			const $root = $(elt);

			if (!$root.length) return;
			const root = $root[0];
			const wrapper = root.querySelector('.project-list-wrapper');
			const rows = root.querySelectorAll('.project-list-item');
			const media = root.querySelector('.project-list-media');
			if (!wrapper || !rows.length || !media) return;
			// Cursor-following preview.
			gsap.set(media, {
				yPercent: -50
			});
			const mediaY = gsap.quickTo(media, 'y', {
				duration: 0.25,
				ease: 'power3.out'
			});
			let pointerX = 0;
			let pointerY = 0;
			let hasPointer = false;
			let activeRow = null;

			function createMedia(row) {
				if (row === activeRow) return;

				const src = row.dataset.image;
				if (!src) return;
				activeRow = row;

				const item = document.createElement('div');
				const img = document.createElement('img');

				item.className = 'project-list-media__item';
				img.src = src;
				img.alt = '';

				item.appendChild(img);
				media.appendChild(item);

				media.classList.add('is-visible');

				gsap.set(item, {
					yPercent: -100
				});

				gsap.set(img, {
					yPercent: 100
				});

				gsap.to(item, {
					yPercent: 0,
					duration: 0.6,
					ease: 'expo.inOut'
				});

				gsap.to(img, {
					yPercent: 0,
					duration: 0.6,
					ease: 'expo.inOut'
				});

				while (media.children.length > 3) {
					media.children[0].remove();
				}
			}

			function hideMedia() {
				activeRow = null;
				media.classList.remove('is-visible');

				gsap.delayedCall(0.4, function() {
					if (!media.classList.contains('is-visible')) {
						media.innerHTML = '';
					}
				});
			}

			function updatePointerPreview() {
				if (!hasPointer) return;

				const rootRect = root.getBoundingClientRect();
				const wrapperRect = wrapper.getBoundingClientRect();
				const isInside = pointerX >= wrapperRect.left &&
					pointerX <= wrapperRect.right &&
					pointerY >= wrapperRect.top &&
					pointerY <= wrapperRect.bottom;

				if (!isInside) {
					hideMedia();
					return;
				}

				mediaY(pointerY - rootRect.top);

				const hoveredRow = document.elementFromPoint(pointerX, pointerY)?.closest('.project-list-item');

				if (hoveredRow && root.contains(hoveredRow)) {
					createMedia(hoveredRow);
				}
			}

			root.addEventListener('mousemove', function(event) {
				pointerX = event.clientX;
				pointerY = event.clientY;
				hasPointer = true;
				updatePointerPreview();
			});

			ScrollTrigger.create({
				trigger: root,
				start: 'top bottom',
				end: 'bottom top',
				onUpdate: updatePointerPreview
			});

			rows.forEach(function(row) {
				row.addEventListener('mouseenter', function() {
					createMedia(row);
				});
				row.addEventListener('focus', function() {
					createMedia(row);
				});
			});
			wrapper.addEventListener('mouseleave', function() {
				hasPointer = false;
				hideMedia();
			});
		},
		endPageAboutParallax: function() {
			if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

			document.querySelectorAll('.end-page-about__media img').forEach(function(image) {
				gsap.fromTo(image, {
					yPercent: -2.5
				}, {
					yPercent: 2.5,
					ease: 'none',
					scrollTrigger: {
						trigger: image.closest('.end-page-about'),
						start: 'top bottom',
						end: 'bottom top',
						scrub: 1
					}
				});
			});
		},
		scrolltriggerAnimations: function(){
			ScrollTrigger.matchMedia({
				'all': function() {  

					$('.js-slidefade-reveal').each(function(){
						var elts = $(this);

						gsap.set(elts, {y: 30, opacity: 0});

						ScrollTrigger.batch(elts, {
							start: "top 90%",
							onEnter: function(batch){  gsap.to(batch, {opacity: 1, y: 0, stagger: 0.45, duration: 0.6, overwrite: true})},
						});
					})

					$('.js-anim-children--fade').each(function(){
						var elts = $(this).children();

						gsap.set(elts, {y: 0, opacity: 0});

						ScrollTrigger.batch(elts, {
							start: "top 90%",
							onEnter: function(batch){  gsap.to(batch, {opacity: 1, y: 0, stagger: 0.45, duration: 0.6, overwrite: true})},
						});
					})

					$('.js-anim-children--slidefade').each(function(){
						var elts = $(this).children();

						gsap.set(elts, {y: 20, opacity: 0});

						ScrollTrigger.batch(elts, {
							start: "top 90%",
							onEnter: function(batch){  gsap.to(batch, {opacity: 1, y: 0, stagger: 0.45, duration: 0.6, overwrite: true})},
						});
					})


					$("[class*='ivanim-']").each(function(){
						const $el = $(this);

						ScrollTrigger.create({
							trigger: $el, 
							id: "inview",
							start: "top bottom",
							onEnter: function(){
								if (!$el.hasClass('is-inview')) {
									$el.addClass('is-inview');
								}
							}
						});
					});
					// Repeat when scrolling back above the element.
					$("[class*='ivanimr-']").each(function(){
						const $el = $(this);

						ScrollTrigger.create({
							trigger: $el, 
							start: "top bottom",
							onEnter: function(){
								if (!$el.hasClass('is-inview')) {
									$el.addClass('is-inview');
								}
							},
							onLeaveBack: function(){ 
								if ($el.hasClass('is-inview')) {
									$el.removeClass('is-inview');
								}
							},
						});
					});
				}
			})

		},

	};


	$(document).ready( function(){
		Site.init();
	})

})($);
